import {ReviewApprovedIcon} from '@github-ui/custom-icons/ReviewApprovedIcon'
import {mergeabilityStatus, Status} from '@github-ui/mergebox/helpers/mergeability-status'
import {ForYouItem} from '../shared/ForYouItem'
import {useMergeabilityData} from './use-mergeability-data'
import {OverviewMergeControl} from './shared/OverviewMergeControl'
import {OverviewUpdateBranchControl} from './shared/OverviewUpdateBranchControl'
import {isForYouRefreshEnabled} from '../shared/for-you-feature-flags'

export function shouldShowReadyToMerge(data: ReturnType<typeof useMergeabilityData>) {
  return (
    !!data &&
    mergeabilityStatus({
      pullRequest: data.mergeBoxPullRequest,
      mergeRequirements: data.mergeRequirements,
      statusChecksData: data.statusChecksData,
    }) === Status.Mergeable
  )
}

// Renders for the author/assignees when the pull request is mergeable ("Ready to merge"),
// offering the relevant merge action so they can complete the merge.
export function ReadyToMerge() {
  const data = useMergeabilityData()

  if (!data || !shouldShowReadyToMerge(data)) return null

  return (
    <ForYouItem
      itemId="ready-to-merge"
      visual={{kind: 'icon', icon: ReviewApprovedIcon, tone: 'success', glyphSize: 16}}
      title="Ready to merge"
      subText="All requirements are met - merge the pull request."
      actions={[
        {
          id: 'update-branch',
          content: isForYouRefreshEnabled() ? <OverviewUpdateBranchControl itemName="ready-to-merge" /> : null,
        },
        {
          id: 'merge-control',
          content: <OverviewMergeControl data={data} itemName="ready-to-merge" />,
        },
      ]}
    />
  )
}
